module.exports = __webpack_public_path__ + "static/media/07-press.1fd56e78.png";